<template>
  <v-row>
    <v-col xl="6" lg="6" md="8" sm="12">
      <v-card class="m-2">
        <v-card-text>
  <v-row>
    <v-col sm="4" md="2">
      <v-subheader class="c-label">Name</v-subheader>
      <v-subheader class="c-label">Kostenstelle</v-subheader>
    </v-col>
    <v-col>
      <v-text-field
          class="hide-label"
          v-model="legr.name"
          :rules="rules.name"
          counter
          maxlength="50"
          hint="Der Name der Leistungsgruppe"
          label="Name"
          @input="$emit('change', legr.id)"
      ></v-text-field>
      <v-select
          class="hide-label"
          v-model="legr.kost"
          :items="kosts"
          label="Kostenstelle"
          hint="Die Kostenstelle der Leistungsgruppe"
          :item-value="'name'"
          :item-text="'name'"
          @input="$emit('change', legr.id)"
          :rules="rules.kost"
      ></v-select>
    </v-col>
  </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "legr_detail",
  props:{
    item: {
      type: Object,
      default: () => {
        return {
          id: '',
          bis_id: '',
          name: '',
          access: '',
          kost: '',
        }
      }
    },
    legrs: {
      type: Array,
      default: () => []
    },
    kosts: {
      type: Array,
      default: () => []
    },
  },
  data () {
    return {
      legr: {
        id: '',
        bis_id: '',
        name: '',
        access: '',
        kost: '',
      },
      canEdit: false,
      rules: {
        name: [val => (val || '').length > 0 || '*erforderlich'],
        kost: [val => (val || '').length > 0 || '*erforderlich'],
      },
    }
  },
  watch: {
    item: {
      handler: function (newVal) {
        this.legr = {...newVal};
      },
      deep: true
    },
  },
  mounted() {
    this.canEdit = this.$cookies.get("ps_username") === 'admin';
    this.legr = {...this.item};
  },
  methods: {
    isValid() {
      return this.legr.name.trim().length > 0;
    },
    resetEdit() {
      this.legr = {...this.item};
    },
    getData() {
      return this.legr;
    }
  }
}
</script>

<style scoped>
  ::v-deep .theme--light.v-input--is-disabled input {
    color: rgba(0, 0, 0, 0.86);
  }

  ::v-deep .hide-label {
    padding-top: 0px !important;
  }

  ::v-deep .hide-label .v-label {
    display: none !important;
  }

  .c-label {
    margin-bottom: 10px;
    color: black;
    font-size: 14px;
    font-weight: 500;
  }
</style>
